export const GSTR1_REPORT_REQUEST = 'GSTR1_REPORT_REQUEST';
export const GSTR1_REPORT_SUCCESS = 'GSTR1_REPORT_SUCCESS';
export const GSTR1_REPORT_FAILURE = 'GSTR1_REPORT_FAILURE';